export const terms = {
  backToHome: "Retour à l'accueil",
  title: "Conditions Générales",
  lastUpdated: "Dernière mise à jour : janvier 2025",
  sections: {
    introduction: {
      title: "1. Identification de l'Entreprise et Champ d'Application",
      paragraph1: "Ces conditions générales s'appliquent à toutes les ventes et livraisons de données d'entreprise par NovaVenture Group BV, située à Krommestraat 48, 2830 Blaasveld, Belgique, avec le numéro d'entreprise 1006303437 et le numéro de TVA BE1006303437.",
      paragraph2: "En passant une commande ou en utilisant nos services, vous acceptez pleinement et inconditionnellement ces conditions générales. Les conditions divergentes de l'acheteur ne s'appliquent pas, sauf acceptation expresse écrite par NovaVenture Group BV."
    },
    services: {
      title: "2. Nature des Services",
      intro: "NovaVenture Group BV vend des données d'entreprise au format Excel à des fins B2B. Les données livrées comprennent uniquement :",
      items: [
        "Noms d'entreprises",
        "Numéros de téléphone fixe (pas de numéros mobiles)",
        "Adresses complètes d'entreprise",
        "Numéros de TVA et numéros d'entreprise"
      ],
      outro: "Nous ne traitons pas les noms de personnes physiques, les adresses e-mail personnelles ou d'autres données personnelles sensibles. Toutes les données proviennent de sources en ligne accessibles au public où les entreprises ont publié leurs informations elles-mêmes."
    },
    usage: {
      title: "3. Utilisation Autorisée",
      intro: "Les données d'entreprise livrées ne peuvent être utilisées que pour :",
      items: [
        "La prospection commerciale légitime conformément à la législation applicable",
        "Le marketing B2B et les contacts commerciaux",
        "Les études de marché et la business intelligence",
        "Les objectifs commerciaux internes au sein de votre organisation"
      ]
    },
    prohibited: {
      title: "4. Utilisation Interdite",
      intro: "Il est expressément interdit à l'acheteur de :",
      items: [
        "Utiliser les données pour le spam ou des pratiques marketing illégales",
        "Revendre, louer ou redistribuer les données sans consentement écrit préalable de NovaVenture Group BV",
        "Utiliser les données à des fins contraires au RGPD ou à d'autres législations applicables",
        "Combiner les données avec d'autres bases de données sans autorisation",
        "Effectuer des contacts non sollicités ou agressifs pouvant nuire à la réputation de NovaVenture Group BV"
      ]
    },
    intellectualProperty: {
      title: "5. Propriété Intellectuelle",
      paragraph1: "Tous les droits de propriété intellectuelle relatifs aux bases de données, à la structure, à la sélection et à la composition des données restent à tout moment la propriété de NovaVenture Group BV.",
      paragraph2: "L'acheteur acquiert uniquement un droit d'utilisation non exclusif et non transférable des données achetées conformément à ces conditions générales. L'ingénierie inverse, la décompilation ou d'autres tentatives de découvrir la structure ou la méthodologie sous-jacente sont interdites."
    },
    disclaimer: {
      title: "6. Clause de Non-Responsabilité et Absence de Garanties",
      intro: "NovaVenture Group BV livre les données d'entreprise 'en l'état' sans aucune garantie. Spécifiquement :",
      items: [
        "Nous ne garantissons pas l'exhaustivité des données",
        "Nous ne garantissons pas l'exactitude ou l'actualité de toutes les données",
        "Les données d'entreprise peuvent être obsolètes en raison de déménagements, faillites ou autres changements",
        "Nous ne sommes pas responsables des modifications de données après livraison",
        "L'acheteur est responsable de la vérification des données si nécessaire"
      ],
      outro: "Bien que nous visions une qualité et une actualité maximales, nous ne pouvons fournir de garanties absolues concernant les informations commerciales accessibles au public."
    },
    liability: {
      title: "7. Limitation de Responsabilité",
      intro: "La responsabilité de NovaVenture Group BV est limitée comme suit :",
      items: [
        "Notre responsabilité totale est limitée au maximum au montant de la facture de l'achat concerné",
        "Nous ne sommes pas responsables des dommages indirects, consécutifs, pertes de profits ou pertes de revenus",
        "Nous ne sommes pas responsables des dommages résultant d'une utilisation incorrecte ou illégale des données par l'acheteur",
        "Nous ne sommes pas responsables des réclamations de tiers découlant de l'utilisation des données par l'acheteur"
      ],
      outro: "Cette limitation de responsabilité ne s'applique pas en cas d'intention ou de négligence grave de NovaVenture Group BV."
    },
    payment: {
      title: "8. Paiement et Facturation",
      intro: "Conditions de paiement :",
      items: [
        "Les factures sont payables dans les 14 jours suivant la date de facturation, sauf accord contraire",
        "En cas de retard de paiement, nous sommes en droit de facturer des intérêts de 10% par an",
        "En cas de non-paiement après rappel, toutes les factures impayées deviennent immédiatement exigibles",
        "Tous les prix sont hors TVA, sauf mention expresse contraire",
        "Les frais de recouvrement et les frais juridiques sont à la charge de l'acheteur en cas de défaut"
      ]
    },
    termination: {
      title: "9. Résiliation et Suspension",
      intro: "NovaVenture Group BV se réserve le droit de :",
      items: [
        "Résilier immédiatement la livraison en cas de violation de ces conditions",
        "Suspendre l'accès aux services en cas de suspicion d'abus",
        "Annuler les commandes en cours sans remboursement en cas d'utilisation interdite",
        "Prendre des mesures juridiques en cas de violations graves"
      ],
      outro: "En cas de résiliation pour défaut de l'acheteur, l'obligation de paiement reste pleinement en vigueur."
    },
    law: {
      title: "10. Droit Applicable et Tribunal Compétent",
      paragraph1: "Ces conditions générales et tous les accords entre NovaVenture Group BV et l'acheteur sont exclusivement régis par le droit belge.",
      paragraph2: "Tous les litiges découlant de ou liés à ces conditions ou à leur exécution seront soumis aux tribunaux compétents de l'arrondissement d'Anvers, division de Malines, sauf disposition impérative contraire."
    },
    dataProtection: {
      title: "11. Protection des Données et Conformité RGPD",
      paragraph1: "L'acheteur reconnaît que les données achetées consistent exclusivement en données d'entreprise accessibles au public et non en données personnelles au sens du RGPD.",
      paragraph2: "Si l'acheteur utilise les données d'une manière qui relève du RGPD, l'acheteur est seul responsable du respect de toute la législation applicable en matière de protection des données. L'acheteur indemnise NovaVenture Group BV contre toutes les réclamations en découlant."
    },
    changes: {
      title: "12. Modifications des Conditions",
      content: "NovaVenture Group BV se réserve le droit de modifier ces conditions générales. Les modifications prennent effet après publication sur notre site web. Pour les accords déjà conclus, les conditions applicables au moment de la commande restent en vigueur."
    },
    severability: {
      title: "13. Divisibilité",
      content: "Si une disposition de ces conditions générales s'avère nulle ou inapplicable, les autres dispositions restent pleinement en vigueur. La disposition nulle sera réputée remplacée par une disposition valide qui correspond le plus possible à l'intention de la disposition originale."
    },
    contact: {
      title: "14. Coordonnées",
      intro: "Pour toute question concernant ces conditions générales ou nos services :",
      company: "NovaVenture Group BV",
      address: "Adresse",
      phone: "Téléphone",
      email: "E-mail",
      businessNumber: "Numéro d'entreprise",
      vatNumber: "Numéro de TVA"
    }
  },
  footer: {
    copyright: "© 2025 NovaVenture Group BV. Tous droits réservés."
  }
};